import React from 'react';

const Image = React.forwardRef(({
  src,
  alt = "Image Name",
  className = "",
  ...props
}, ref) => {

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = "/assets/images/no_image.png"
      }}
      {...props}
    />
  );
});

export default Image;
